import { Moment } from "moment";
import { Perfil } from "./enum";

export default class Update implements IUpdate {
  public id!: string;
  public perfil!: Perfil[];
  public mensagem!: string;
  public dataUpdate!: Moment;

  constructor(param: IUpdate) {
    Object.assign(this, param);
  }
}

interface IUpdate {
  id: string;
  perfil: Perfil[];
  mensagem: string;
  dataUpdate: Moment;
}
